<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-refresh @invoke-method="dbGetScrapAuthorizations(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="scrap_authorizations" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openScrapAuthorizationForm(props.item)">
                                <td>{{ props.item.scrap_auth_id }}</td>
                                <td>{{ props.item.nonconformance_id ? props.item.nonconformance_id : "---" }}</td>
                                <td class="text-center">
                                    <v-chip :color="props.item.corrective_action == '1' ? 'success' : 'error'" text-color="white" small>
                                        {{ props.item.corrective_action == "1" ? "In Process" : "Not In Process" }}
                                    </v-chip>
                                </td>
                                <td>{{ props.item.car_number }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.part_id }}</td>
                                <td>{{ props.item.batch_id }}</td>
                                <!-- <td class="text-center">
                                    <label>
                                        <strong>{{ props.item.quality_mgr_id != null ? props.item.quality_mgr : "---" }}</strong>
                                    </label>
                                    <br />
                                    <small>{{ props.item.quality_mgr_date != null ? props.item.quality_mgr_date : "" }}</small>
                                </td>
                                <td class="text-center">
                                    <label>
                                        <strong>{{ props.item.sales_mgr_id != null ? props.item.sales_mgr : "---" }}</strong>
                                    </label>
                                    <br />
                                    <small>{{ props.item.sales_mgr_date != null ? props.item.sales_mgr_date : "" }}</small>
                                </td>
                                <td class="text-center">
                                    <label>
                                        <strong>{{ props.item.ehs_mgr_id != null ? props.item.ehs_mgr : "---" }}</strong>
                                    </label>
                                    <br />
                                    <small>{{ props.item.ehs_mgr_date != null ? props.item.ehs_mgr_date : "" }}</small>
                                </td>
                                <td class="text-center">
                                    <label>
                                        <strong>{{ props.item.production_mgr_id != null ? props.item.production_mgr : "---" }}</strong>
                                    </label>
                                    <br />
                                    <small>{{ props.item.production_mgr_date != null ? props.item.production_mgr_date : "" }}</small>
                                </td>
                                <td class="text-center">
                                    <label>
                                        <strong>{{ props.item.executive_id != null ? props.item.executive : "---" }}</strong>
                                    </label>
                                    <br />
                                    <small>{{ props.item.executive_date != null ? props.item.executive_date : "" }}</small>
                                </td> -->
                                <td>{{ props.item.qty_scrapped }}</td>
                                <td>{{ props.item.rma_number }}</td>
                                <td>${{ props.item.part_cost_estimate }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="scrap_authorizations"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="scrap_authorization_dialog" max-width="800">
                <v-card>
                    <v-form ref="form_scrap_authorization">
                        <v-card-title>
                            <span class="headline">{{
                                scrap_authorization.scrap_auth_id ? $t("lang.edit_scrap_authorization") : $t("lang.add_scrap_authorization")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeScrapAuthorizationDialog"
                                :dialog-status="scrap_authorization_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text class="pa-2">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex style="display: none">
                                        <v-text-field
                                            v-model="scrap_authorization.scrap_auth_id"
                                            :label="`${$t('lang.scrap_auth_id')} *`"
                                            :counter="showCounter(scrap_authorization.scrap_auth_id, 'scrap_authorizations.scrap_auth_id')"
                                            :rules="ifValid('scrap_authorizations.scrap_auth_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-alert
                                            style="width: 100%; padding: 10px !important; color: black; margin: 0px !important"
                                            :value="true"
                                            type="info"
                                            text-color="black"
                                            color="#f8eea1"
                                            >{{ $t("lang.info_scrap_authorization") }}</v-alert
                                        >
                                    </v-flex>
                                    <!-- <v-flex xs12>
                                        <v-text-field
                                            v-focus="scrap_authorization_dialog"
                                            v-model="scrap_authorization.scrap_auth_id"
                                            :label="`${$t('lang.scrap_auth_id')} *`"
                                            :counter="showCounter(scrap_authorization.scrap_auth_id, 'scrap_authorizations.scrap_auth_id')"
                                            :rules="ifValid('scrap_authorizations.scrap_auth_id')"
                                        ></v-text-field>
                                    </v-flex> -->
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="scrap_authorization.nonconformance_id"
                                            :label="$t('lang.nonconformance')"
                                            :rules="ifValid('scrap_authorizations.nonconformance_id')"
                                            disabled
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="scrap_authorization.batch_id"
                                            :label="$t('lang.batch_id')"
                                            :rules="ifValid('scrap_authorizations.batch_id')"
                                            disabled
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6>
                                        <v-text-field v-model="scrap_authorization.company" :label="$t('lang.company_id')" disabled></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="scrap_authorization.part_id"
                                            :label="$t('lang.part_id')"
                                            :rules="ifValid('scrap_authorizations.part_id')"
                                            disabled
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs5>
                                        <v-switch
                                            v-model="scrap_authorization.corrective_action"
                                            :label="scrap_authorization.corrective_action == '1' ? $t('lang.in_process') : $t('lang.not_in_process')"
                                            true-value="1"
                                            false-value="0"
                                        ></v-switch>
                                    </v-flex>
                                    <v-flex xs7>
                                        <v-text-field
                                            v-if="scrap_authorization.corrective_action == '1'"
                                            v-model="scrap_authorization.car_number"
                                            :label="$t('lang.car_number')"
                                            :counter="showCounter(scrap_authorization.car_number, 'scrap_authorizations.car_number')"
                                            :rules="ifValid('scrap_authorizations.car_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs8>
                                        <bc-autocomplete
                                            v-model="scrap_authorization.quality_mgr_id"
                                            :label="$t('lang.quality_mgr_id')"
                                            :items="people_options"
                                            item-value="user_id"
                                            item-text="combined_name"
                                            :rules="ifValid('scrap_authorizations.quality_mgr_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs4>
                                        <bc-date-picker
                                            v-model="scrap_authorization.quality_mgr_date"
                                            :label="$t('lang.quality_mgr_date')"
                                            :rules="ifValid('scrap_authorizations.quality_mgr_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs8>
                                        <bc-autocomplete
                                            v-model="scrap_authorization.sales_mgr_id"
                                            :label="$t('lang.sales_mgr_id')"
                                            :items="people_options"
                                            item-value="user_id"
                                            item-text="combined_name"
                                            :rules="ifValid('scrap_authorizations.sales_mgr_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs4>
                                        <bc-date-picker
                                            v-model="scrap_authorization.sales_mgr_date"
                                            :label="$t('lang.sales_mgr_date')"
                                            :rules="ifValid('scrap_authorizations.sales_mgr_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs8>
                                        <bc-autocomplete
                                            v-model="scrap_authorization.ehs_mgr_id"
                                            :label="$t('lang.ehs_mgr_id')"
                                            :items="people_options"
                                            item-value="user_id"
                                            item-text="combined_name"
                                            :rules="ifValid('scrap_authorizations.ehs_mgr_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs4>
                                        <bc-date-picker
                                            v-model="scrap_authorization.ehs_mgr_date"
                                            :label="$t('lang.ehs_mgr_date')"
                                            :rules="ifValid('scrap_authorizations.ehs_mgr_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs8>
                                        <bc-autocomplete
                                            v-model="scrap_authorization.production_mgr_id"
                                            :label="$t('lang.production_mgr_id')"
                                            :items="people_options"
                                            item-value="user_id"
                                            item-text="combined_name"
                                            :rules="ifValid('scrap_authorizations.production_mgr_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs4>
                                        <bc-date-picker
                                            v-model="scrap_authorization.production_mgr_date"
                                            :label="$t('lang.production_mgr_date')"
                                            :rules="ifValid('scrap_authorizations.production_mgr_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs8>
                                        <bc-autocomplete
                                            v-model="scrap_authorization.executive_id"
                                            :label="$t('lang.executive_id')"
                                            :items="people_options"
                                            item-value="user_id"
                                            item-text="combined_name"
                                            :rules="ifValid('scrap_authorizations.executive_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs4>
                                        <bc-date-picker
                                            v-model="scrap_authorization.executive_date"
                                            :label="$t('lang.executive_date')"
                                            :rules="ifValid('scrap_authorizations.executive_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-text-field
                                            v-model="scrap_authorization.qty_scrapped"
                                            :label="`${$t('lang.qty_scrapped')} *`"
                                            :counter="showCounter(scrap_authorization.qty_scrapped, 'scrap_authorizations.qty_scrapped')"
                                            :rules="ifValid('scrap_authorizations.qty_scrapped')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-text-field
                                            v-model="scrap_authorization.rma_number"
                                            :label="$t('lang.rma_number')"
                                            :counter="showCounter(scrap_authorization.rma_number, 'scrap_authorizations.rma_number')"
                                            :rules="ifValid('scrap_authorizations.rma_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-text-field
                                            v-model="scrap_authorization.part_cost_estimate"
                                            :label="$t('lang.part_cost_estimate')"
                                            :counter="showCounter(scrap_authorization.part_cost_estimate, 'scrap_authorizations.part_cost_estimate')"
                                            :rules="ifValid('scrap_authorizations.part_cost_estimate')"
                                            prefix="$"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="scrap_authorization.scrap_auth_id" color="error" @mouseup.left="$refs.delete_scrap_authorizations.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeScrapAuthorizationDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn v-if="scrap_authorization.scrap_auth_id" color="primary" @mouseup.left="showPrinter(scrap_authorization.scrap_auth_id)">{{
                                $t("lang.print")
                            }}</v-btn>
                            <v-btn color="success" @click="saveScrapAuthorizations">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_scrap_authorizations"
                :heading="$t('lang.delete_scrap_authorization')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteScrapAuthorizations(scrap_authorization.scrap_auth_id)"
            ></delete-confirmation-dialog>
            <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openScrapAuthorizationForm" },
                { title: this.$t("lang.refresh"), action: "dbGetScrapAuthorizations", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.scrap_auth_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.nonconformance_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.corrective_action"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.car_number"), sortable: false, width: "5%" },
                { text: this.$t("lang.company_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.part_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.batch_id"), sortable: false, width: "5%" },
                // { text: this.$t("lang.quality_mgr_id"), sortable: false, width: "5%" },
                // { text: this.$t("lang.sales_mgr_id"), sortable: false, width: "5%" },
                // { text: this.$t("lang.ehs_mgr_id"), sortable: false, width: "5%" },
                // { text: this.$t("lang.production_mgr_id"), sortable: false, width: "5%" },
                // { text: this.$t("lang.executive_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.qty_scrapped"), sortable: false, width: "5%" },
                { text: this.$t("lang.rma_number"), sortable: false, width: "5%" },
                { text: this.$t("lang.part_cost_estimate"), sortable: false, width: "5%" },
            ],
            enableAddModal: true,
            enableEditModal: true,
            customers: null,
            scrap_authorization: {},
            filter: {
                search: "",
                status: "1",
                company_id: "",
            },
            scrap_authorization_dialog: false,
            dbGetScrapAuthorizations: _.debounce(this.getScrapAuthorizations, 1500, { maxWait: 1500, leading: true, trailing: false }),
            file_name: "",
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchScrapAuthorizations", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.scrap_authorization) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchScrapAuthorizations({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.scrap_authorization) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.scrap_authorizations.scrap_authorizations_filter,
            page: (state) => state.scrap_authorizations.page,
            rules_scrap_authorizations: (state) => state.scrap_authorizations.rules_scrap_authorizations,
            scrap_authorization_status_options: (state) => state.settings.scrap_authorization_status_options,
            scrap_authorizations: (state) => state.scrap_authorizations.scrap_authorizations,
            people_options: (state) => state.people.person_options,
            nonconformances: (state) => state.nonconformance.nonconformances,
            parts: (state) => state.parts.parts,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchScrapAuthorizations", "saveScrapAuthorization", "deleteScrapAuthorization", "fetchPeople", "printScrapAuthorization"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openScrapAuthorizationForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_scrap_authorization)
                        item ? this.$refs.form_scrap_authorization.resetValidation() : this.$refs.form_scrap_authorization.reset();

                    this.$nextTick(() => {
                        this.scrap_authorization = item != null ? this.assignObj2(item, this.rules_scrap_authorizations) : {};
                        this.scrap_authorization_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "scrap_authorization", params: { id: item.scrap_auth_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_scrap_authorization)
                        item ? this.$refs.form_scrap_authorization.resetValidation() : this.$refs.form_scrap_authorization.reset();
                    this.scrap_authorization_dialog = true;
                    console.log(this.scrap_authorization);
                } else {
                    this.$router.push({ name: "scrap_authorization" });
                }
            }
        },
        saveScrapAuthorizations() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_scrap_authorization")) {
                    let body = this.prepForm(this.scrap_authorization, this.rules_scrap_authorizations);

                    this.saveScrapAuthorization({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getScrapAuthorizations();
                                this.closeScrapAuthorizationDialog();
                            } else {
                                this.$router.push({ name: "scrap_authorization", params: { id: data.scrap_auth_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteScrapAuthorizations(id = null) {
            this.deleteScrapAuthorization({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getScrapAuthorizations();
                    this.closeScrapAuthorizationDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeScrapAuthorizationDialog() {
            this.scrap_authorization_dialog = false;
            this.$refs.delete_scrap_authorizations.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getScrapAuthorizations(pg_refresh = false) {
            this.startLoader();

            this.fetchScrapAuthorizations({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.scrap_authorization_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        showPrinter(auth_id) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.printScrapAuthorization({ id: auth_id }).then((data) => {
                if (typeof data != "undefined" && data.scrap_authorization) {
                    this.file_name = data.scrap_authorization.file_name;
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        refresh() {
            if (this.people_options.length == 0) this.fetchPeople({ body: { options: 1 } });

            // if (this.nonconformances == null) {
            //     this.$store
            //         .dispatch("fetchNonconformance", {
            //             url: "nonconformance",
            //             method: "get",
            //             stateProperty: "nonconformances",
            //             commit: true,
            //             body: {},
            //         })
            //         .then((data) => {
            //             if (typeof data !== "undefined" && data.nonconformances) {
            //                 this.finishLoader();
            //             } else {
            //                 this.$router.push({ name: "dashboard", replace: true });
            //             }
            //         });
            // }

            // if (!this.$isSet(this.parts)) {
            //     this.$store
            //         .dispatch("fetchPart", {
            //             url: "parts",
            //             method: "get",
            //             stateProperty: "parts",
            //             commit: true,
            //             body: {},
            //         })
            //         .then((data) => {
            //             if (typeof data !== "undefined" && data.parts) {
            //                 this.finishLoader();
            //             } else {
            //                 this.$router.push({ name: "dashboard", replace: true });
            //             }
            //         });
            // }
        },
    },
    mounted() {
        this.refresh();
    },
};
</script>
